const types = {
  SET_USER_PREFERENCES: 'SET_USER_PREFERENCES',
  RESET_USER_PREFERENCES: 'RESET_USER_PREFERENCES',
  SET_STARRED_ITEMS_IDS: 'SET_STARRED_ITEMS_IDS',
}

export default types;

